export const MY_ASSETS_PATH = "/my-assets";
